<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <blockquote class="blockquote">
          <p class="mb-0">Version 1.3:</p>
          <div style="margin-left: 20px;">
            <a href="#/">Weather</a>
            <ul style="font-size: 12px; font-family: 'Gill Sans MT'">
              <li>Current weather of current place. Device uses gps coordinates</li>
              <li>Forecast for a future of 5 days every 3 hours for current place.</li>
            </ul>
          </div>
        </blockquote>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <blockquote class="blockquote">
          <p class="mb-0" @click="ver1_2 = !ver1_2">Version 1.2:</p>
          <div style="margin-left: 20px;" v-if="ver1_2">
            <a href="#/news">News page</a>
            <ul style="font-size: 12px; font-family: 'Gill Sans MT'">
              <li>New functions with description for the current version of crm</li>
            </ul>
            <a href="/">Unread tickets status</a>
            <ul style="font-size: 12px; font-family: 'Gill Sans MT'">
              <li>For desktop version there is an icon messages located at the top of your display. It shows how many unread tickets you have</li>
              <li>For mobile version there is a item in menu, where you logout</li>
            </ul>
            <a href="#/tickets?is_read=0">Task page:</a>
            <ul style="font-size: 12px; font-family: 'Gill Sans MT'">
              <li>Create a new ticket button</li>
              <li>Filters shows all fields which you could filter</li>
              <li>Get tickets button shows you all tickets according to your filter</li>
              <li>Default value of Get tickets buttons is to show all existing tickets</li>
              <li>Default value of opening task page is to show all unread and new tickets</li>
            </ul>
            <a href="#/tickets/?ticket_id=1">Ticket card:</a>
            <ul style="font-size: 12px; font-family: 'Gill Sans MT'">
              <li>Ticket number</li>
              <li>An employee who was an author of the ticket</li>
              <li>Final date of the ticket means when it has to be complete</li>
              <li>Subject of the ticket is a short description</li>
              <li>Remove and restore are buttons which is available for the author</li>
              <li>Complete button is button to finish the ticket. Everybody can press it</li>
              <li>Confirm is a button for an author of the ticket. Only person who created the ticket can confirm.</li>
              <li>Open ticket is button which shows detailed information of the ticket</li>
            </ul>
            <a href="#/ticket-details/?ticket-id=0">New ticket/detailed information of a ticket page. Fields:</a>
            <ul style="font-size: 12px; font-family: 'Gill Sans MT'">
              <li>An subject of ticket is short description of task.</li>
              <li>A priority is an importance level of the ticket</li>
              <li>A final date is the date when ticket has to be complete</li>
              <li>A responsible employee is a person who is in charge</li>
              <li>A description is a detailed information about the task</li>
              <li>Every ticket has a number which is identical, so you can use it in filter</li>
            </ul>
            <a href="#/ticket-details/?ticket-id=0">New ticket/detailed information of a ticket page. Buttons:</a>
            <ul style="font-size: 12px; font-family: 'Gill Sans MT'">
              <li>Submit, press it when the task has done. Everybody can complete the ticket. </li>
              <li>Confirm is a button for an author of the ticket. Only person who created the ticket can confirm.</li>
              <li>Decline button is a button to cancel a completion of the ticket.</li>
              <li>Delete and Restore buttons are deleted and restored ticket. Only the author can do it. There is a discussion panel for comments.</li>
            </ul>
            <a href="#/ticket-details/?ticket-id=1">Have a question about tickets?</a>
            <ul style="font-size: 12px; font-family: 'Gill Sans MT'">
              <li>You can ask in the comment panel of the <a href="#/ticket-details/?ticket-id=1">ticket #1</a></li>
              <li>If you have another question or suggestion about new function you can create new ticket for me and ask there</li>
            </ul>
          </div>
        </blockquote>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "News",
      data(){
          return{
            ver1_2:false,
          }
      },
    }
</script>

<style scoped>

</style>
